import type {ApiError} from '~/openapi';

export default defineNuxtPlugin({
	name: 'fix-error-status-code',
	enforce: 'pre',
	setup(nuxtApp) {
		// Fix errors in app:error hook (runs on client from showError)
		nuxtApp.hook('app:error', (error: any) => {
			fixErrorStatusCode(error);
		});

		// Fix errors in vue:error hook (runs on both server and client)
		nuxtApp.hook('vue:error', (error: any) => {
			fixErrorStatusCode(error);
		});
	},
});

function fixErrorStatusCode(error: any) {
	// Handle ApiError from OpenAPI client (has .status, not .statusCode)
	if (error && typeof error === 'object' && 'status' in error && 'statusText' in error && 'url' in error) {
		(error as any).statusCode = (error as ApiError).status;
		(error as any).statusMessage = (error as ApiError).statusText;
		(error as any).data = (error as ApiError).body;
		return;
	}

	// Handle errors nested in error.message (from createError)
	if (error?.message && typeof error.message === 'object' && 'statusCode' in error.message) {
		error.statusCode = error.message.statusCode;
		error.statusMessage = error.message.statusMessage || '';
		error.data = error.message.data;
		return;
	}

	// Handle errors nested in error.cause.message (deeply nested H3Error)
	if (error?.cause?.message && typeof error.cause.message === 'object' && 'statusCode' in error.cause.message) {
		error.statusCode = error.cause.message.statusCode;
		error.statusMessage = error.cause.message.statusMessage || '';
		error.data = error.cause.message.data;
		return;
	}

	// Handle errors nested in error.cause - case 1: createError with statusCode
	if (error?.cause && typeof error.cause === 'object' && 'statusCode' in error.cause) {
		error.statusCode = error.cause.statusCode;
		error.statusMessage = error.cause.statusMessage || '';
		error.data = error.cause.data;
		return;
	}

	// Handle errors nested in error.cause - case 2: ApiError with status
	if (error?.cause && typeof error.cause === 'object' && 'status' in error.cause && 'statusText' in error.cause && 'url' in error.cause) {
		error.statusCode = (error.cause as ApiError).status;
		error.statusMessage = (error.cause as ApiError).statusText;
		error.data = (error.cause as ApiError).body;
	}
}
